import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'foundations-theming/utils';
import { getScreenReaderOnlyStyles } from '../../utils/styles/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSpan = styled.span.withConfig({
  displayName: "ScreenReaderOnly__StyledSpan",
  componentId: "sc-9kcv2g-0"
})(({
  theme
}) => {
  return Object.assign({}, getScreenReaderOnlyStyles(theme));
});
export const ScreenReaderOnly = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledSpan, Object.assign({}, rest, {
    children: children
  }));
};